import { useCallback } from 'react';

import { IUser } from '@model';
import {
  GRAPHQL_HEADER,
  httpMethods,
  IGraphQlQuery,
  useHttpClientAwaitable,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { ApiSectionNamespace } from '../apiConstants';

import { USER_CONFIGURATION_QUERY } from './graphql';
import { IUserSettingsGatewayResponse } from './model';

const mappingFunction = ({ user: { data } }: IUserSettingsGatewayResponse): IUser => ({
  ...data,
  abTests: data.abTests.reduce((prev, current) => {
    prev.set(current.key, current.value);
    return prev;
  }, new Map<number, number>()),
});

export const useGetUserSettingsOnDemand = (): IHttpHookResponseAwaitable<IUser> => {
  const { request: asyncRequest } = useHttpClientAwaitable<IUser, IGraphQlQuery, IUserSettingsGatewayResponse>({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EConfigurationApiKeys.CONFIG_USER_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(async () => asyncRequest({ data: { query: USER_CONFIGURATION_QUERY } }), [asyncRequest]);

  return { request };
};
